/**
 * Asserts that a value is of type `never`, used for exhaustive checking in switch statements.
 *
 * When used in the `default` case of a switch statement, TypeScript will error at compile-time
 * if a new enum/union value is added but not handled in the switch cases.
 *
 * @param x - The value to assert as `never`. In practice, this should only be reachable
 *            if a new case is added to the discriminated union/enum without a corresponding
 *            case handler.
 * @throws {Error} Always throws an error with a message indicating an unhandled case.
 *
 * @example
 *
 * switch (activeNav) {
 *   case NavItem.Summary:
 *     return <Summary />;
 *   case NavItem.DealOverview:
 *     return <DealOverview />;
 *   default:
 *     assertNever(activeNav); // TypeScript error if new NavItem added
 * }
 */
export default function assertNever(x: never): never {
    throw new Error(`Case not handled: ${String(x)}`);
}
